import React from "react";
import {  BellIcon } from "@heroicons/react/24/outline";
import { Disclosure } from "@headlessui/react";
import { Link, useLocation } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function DisclosurePanel({ routes, user, userNavigation }) {
  let location = useLocation();
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  return (
    <Disclosure.Panel className="md:hidden">
      <div className="space-y-1 px-2 pb-3 pt-2 sm:px-3">
        {routes.map((route, index) => (<Link key={index} to={route.layout + "/" + route.path}>
          <Disclosure.Button
            key={index}
            as="a"
            className={classNames(
            activeRoute(route.path) === true
                ? "bg-gray-900 text-white"
                : "text-gray-300 hover:bg-gray-700 hover:text-white",
              "block rounded-md px-3 py-2 text-base font-medium"
            )}
            aria-current={activeRoute(route.path) === true ? "page" : undefined}
          >
            {route.name}
          </Disclosure.Button>
        </Link>
        ))}
      </div>
      <div className="border-t border-gray-700 pb-3 pt-4">
        <div className="flex items-center px-5">
          <div className="flex-shrink-0">
           {/* {user.imageUrl ?  */}
           <img
              className="h-10 w-10 rounded-full"
              src={user.imageUrl}
              alt=""
            />
             {/* : <span className=" text-white font-extrabold ">{user.username.charAt(0)}</span>} */}
          </div>
          <div className="ml-3">
            <div className="text-base font-medium text-white">{user.username}</div>
            <div className="text-sm font-medium text-gray-400">
              {user.email}
            </div>
          </div>
          <button
            type="button"
            className="relative ml-auto flex-shrink-0 rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
          >
            <span className="absolute -inset-1.5" />
            <span className="sr-only">View notifications</span>
            <BellIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="mt-3 space-y-1 px-2">
          {userNavigation.map((item, index) => (
            <Disclosure.Button
              key={index}
              as="a"
              href={item.href}
              className="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white"
            >
              {item.name}
            </Disclosure.Button>
          ))}
        </div>
      </div>
    </Disclosure.Panel>
  );
}
